import { createContext, useCallback, useContext, useEffect, useState } from "react";

const HelpContext = createContext(null);

// Maps the current pathname to a module_id so Help opens contextually.
const ROUTE_MODULE = [
  [/^\/seo-meta/, "seo_meta"],
  [/^\/seo\b/, "seo"],
  [/^\/faq/, "faq"],
  [/^\/theme-design/, "theme_design"],
];

export function moduleForPath(pathname) {
  for (const [re, key] of ROUTE_MODULE) if (re.test(pathname)) return key;
  return "";
}

export const HelpProvider = ({ children }) => {
  const [helpOpen, setHelpOpen] = useState(false);
  const [cmdOpen, setCmdOpen] = useState(false);

  const openHelp = useCallback(() => setHelpOpen(true), []);
  const openCommand = useCallback(() => setCmdOpen(true), []);

  // Global ⌘K / Ctrl+K to toggle the command palette.
  useEffect(() => {
    const onKey = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        setCmdOpen((o) => !o);
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return (
    <HelpContext.Provider value={{ helpOpen, setHelpOpen, openHelp, cmdOpen, setCmdOpen, openCommand }}>
      {children}
    </HelpContext.Provider>
  );
};

export const useHelp = () => useContext(HelpContext);
